import { defineComponent as _defineComponent } from 'vue'
import {ref, watch} from "vue";

type vTelInputProps = {
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vTelInput',
  props: {
    value: null
  },
  emits: ['update:value'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string;
};




const _value = ref(props.value);

watch(_value, (newValue) => {
  emit('update:value', newValue);
});

return { __sfc: true,props, emit, _value }
}

})